import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { ClientAuthProvider, useClientAuth } from "@/lib/clientAuth";
import AppShell from "@/components/AppShell";
import PwaInstallPrompt from "@/components/PwaInstallPrompt";
import Login from "@/pages/Login";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Masters from "@/pages/Masters";
import Jobs from "@/pages/Jobs";
import BulkImport from "@/pages/BulkImport";
import UnresolvedDrafts from "@/pages/UnresolvedDrafts";
import Challans from "@/pages/Challans";
import EmployeeMaster from "@/pages/EmployeeMaster";
import Purchases from "@/pages/Purchases";
import Transfers from "@/pages/Transfers";
import CurrentStock from "@/pages/CurrentStock";
import DailyReport from "@/pages/DailyReport";
import ClientLedger from "@/pages/ClientLedger";
import OpeningStock from "@/pages/OpeningStock";
import AuditLog from "@/pages/AuditLog";
import ClientLogin from "@/pages/ClientLogin";
import ClientPortal from "@/pages/ClientPortal";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center text-zinc-500 text-sm">Loading…</div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function ClientProtected({ children }) {
  const { client, ready } = useClientAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-zinc-500 text-sm">Loading…</div>;
  if (!client) return <Navigate to="/client-login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider><ClientAuthProvider>
      <BrowserRouter>
        <PwaInstallPrompt />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Landing />} />
          <Route path="/client-login" element={<ClientLogin />} />
          <Route path="/client-portal" element={<ClientProtected><ClientPortal /></ClientProtected>} />
          <Route path="/" element={<Protected><AppShell /></Protected>}>
            <Route path="app" element={<Dashboard />} />
            <Route path="jobs" element={<Jobs />} />
            <Route path="jobs/bulk" element={<BulkImport />} />
            <Route path="jobs/unresolved" element={<UnresolvedDrafts />} />
            <Route path="challans" element={<Challans />} />
            <Route path="employees" element={<EmployeeMaster />} />
            <Route path="purchases" element={<Purchases />} />
            <Route path="transfers" element={<Transfers />} />
            <Route path="stock" element={<CurrentStock />} />
            <Route path="daily-report" element={<DailyReport />} />
            <Route path="ledger" element={<ClientLedger />} />
            <Route path="masters" element={<Masters />} />
            <Route path="opening-stock" element={<OpeningStock />} />
            <Route path="audit" element={<AuditLog />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ClientAuthProvider></AuthProvider>
  );
}
